import React from "react";
import Select from "react-select";
import { getSelectStyles } from "./selectStyles";

const MultiSelect = ({
  label,
  name,
  id,
  options = [],
  selectedValues = [],
  onSelect,
  onRemove,
  onChangeHandler,
  required = false,
  displayValue = "name",
  placeholder = "Select...",
  closeOnSelect = false,
  hideSelectedOptions = true,
  isMulti = true,
  singleSelect = false,
  disabled = false,
  classNamePrefix = "react-select",
  styles,
  ...rest
}) => {
  const allowMulti = singleSelect ? false : isMulti;

  const normalizedOptions = (options || []).map((option) => {
    if (option && typeof option === "object") {
      return option;
    }

    return {
      id: option,
      [displayValue]: String(option ?? ""),
      value: option,
      label: String(option ?? ""),
    };
  });

  const normalizedSelectedValues = (Array.isArray(selectedValues)
    ? selectedValues
    : selectedValues
      ? [selectedValues]
      : []
  ).map((value) => {
    if (value && typeof value === "object") {
      return value;
    }

    const matchedOption = normalizedOptions.find(
      (option) =>
        `${option?.id ?? option?.value ?? option?.[displayValue] ?? ""}` ===
        `${value}`
    );

    return (
      matchedOption || {
        id: value,
        [displayValue]: String(value ?? ""),
        value,
        label: String(value ?? ""),
      }
    );
  });

  const handleChange = (selectedOptions, actionMeta) => {
    const updatedValues = allowMulti
      ? selectedOptions || []
      : selectedOptions
        ? [selectedOptions]
        : [];

    if (onChangeHandler) {
      onChangeHandler(updatedValues, actionMeta);
      return;
    }

    if (actionMeta?.action === "select-option" && onSelect) {
      onSelect(updatedValues, actionMeta);
      return;
    }

    if (
      ["remove-value", "pop-value", "clear", "deselect-option"].includes(
        actionMeta?.action
      ) &&
      onRemove
    ) {
      onRemove(updatedValues, actionMeta);
    }
  };

  const selectedValue = allowMulti
    ? normalizedSelectedValues
    : normalizedSelectedValues?.[0] || null;

  return (
    <div className="form-group">
      {label && (
        <label
          htmlFor={id || name}
          className="mb-1 mt-1 text-capitalize fw-semibold"
        >
          {label}
          {required && <i className="text-danger ms-1">*</i>}
        </label>
      )}

      <Select
        inputId={id || name}
        name={name}
        options={normalizedOptions}
        value={selectedValue}
        isMulti={allowMulti}
        isDisabled={disabled}
        placeholder={placeholder}
        closeMenuOnSelect={closeOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        onChange={handleChange}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        menuPosition="fixed"
        styles={getSelectStyles({}, styles)}
        getOptionLabel={(option) => option?.[displayValue] || ""}
        getOptionValue={(option) =>
          option?.id?.toString() ||
          option?.value?.toString() ||
          option?.[displayValue]?.toString() ||
          ""
        }
        classNamePrefix={classNamePrefix}
        {...rest}
      />
    </div>
  );
};

export default MultiSelect;
